import { Check, Minus, Plus, X } from "lucide-react";

function QtyInput({ item, onChange }) {
  const n = Number(item.qty) || 0;
  const set = (v) => onChange(v > 0 ? String(v) : "");
  return (
    <div className="flex items-center rounded-full border border-white/20 bg-white/5" data-testid={`picker-qty-${item.id}`}>
      <button type="button" onClick={() => set(n - 1)} aria-label="Decrease" data-testid={`picker-qty-dec-${item.id}`} className="h-8 w-8 flex items-center justify-center text-white/70 hover:text-white">
        <Minus size={14} />
      </button>
      <input
        inputMode="numeric"
        value={item.qty}
        placeholder="Qty"
        onChange={(e) => set(parseInt(e.target.value.replace(/\D/g, "").slice(0, 6), 10) || 0)}
        data-testid={`picker-qty-input-${item.id}`}
        className="w-12 bg-transparent text-center text-sm text-white placeholder:text-white/40 outline-none"
      />
      <button type="button" onClick={() => set(n + 1)} aria-label="Increase" data-testid={`picker-qty-inc-${item.id}`} className="h-8 w-8 flex items-center justify-center text-white/70 hover:text-white">
        <Plus size={14} />
      </button>
    </div>
  );
}

function PickTile({ p, on, onToggle }) {
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-pressed={on}
      data-testid={`picker-tile-${p.id}`}
      className={`relative flex items-center gap-2 p-2 pr-3 rounded-xl border text-left transition-[background-color,border-color] duration-200 ${
        on ? "border-[#F5B800] bg-[#F5B800]/15" : "border-white/15 bg-white/5 hover:bg-white/10"
      }`}
    >
      <span className="h-9 w-9 rounded-lg overflow-hidden shrink-0" style={{ backgroundColor: p.bg }}>
        <img src={p.image} alt="" className="w-full h-full object-contain p-0.5" />
      </span>
      <span className="text-[13px] sm:text-sm font-semibold text-white leading-tight min-w-0 break-words">{p.name}</span>
      <span className={`ml-auto h-5 w-5 rounded-full shrink-0 flex items-center justify-center ${on ? "bg-[#F5B800] text-[#111]" : "border border-white/30"}`}>
        {on && <Check size={12} strokeWidth={3} />}
      </span>
    </button>
  );
}

export function ProductPicker({ products, enquiry }) {
  const { has, toggle, remove, setQty } = enquiry;
  const items = enquiry.items.filter((i) => products.some((p) => p.id === i.id));
  if (!products.length) return null;
  return (
    <div className="mt-6" data-testid="product-picker">
      <div className="flex items-baseline justify-between gap-3">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-white/80">Products of interest</div>
        <div className="text-xs text-white/50" data-testid="picker-count">
          {items.length ? `${items.length} selected` : "Optional — pick one or more"}
        </div>
      </div>
      <div className="mt-3 grid grid-cols-1 min-[400px]:grid-cols-2 sm:grid-cols-3 gap-2">
        {products.map((p) => (
          <PickTile key={p.id} p={p} on={has(p.id)} onToggle={() => toggle(p)} />
        ))}
      </div>
      {items.length > 0 && (
        <ul className="mt-4 divide-y divide-white/10 rounded-2xl border border-white/15 bg-white/5" data-testid="picker-selected-list">
          {items.map((i) => (
            <li key={i.id} className="flex flex-wrap items-center gap-x-3 gap-y-2 px-3 sm:px-4 py-2.5" data-testid={`picker-row-${i.id}`}>
              <span className="text-sm font-semibold text-white min-w-0 flex-1 basis-full min-[400px]:basis-0">{i.name}</span>
              <span className="hidden sm:inline text-[10px] uppercase tracking-widest text-white/40">Packs</span>
              <QtyInput item={i} onChange={(v) => setQty(i.id, v)} />
              <button type="button" onClick={() => remove(i.id)} aria-label={`Remove ${i.name}`} data-testid={`picker-remove-${i.id}`} className="h-8 w-8 rounded-full flex items-center justify-center text-white/50 hover:text-white hover:bg-white/10">
                <X size={14} />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
